<template>
    <div class="main-container-page mx-0">
      <div class="row">
        <div class="col-12 d-flex justify-content-end">
          <refresh-information class="mr-3"/>
        </div>
      </div>
      <div class="row px-2" :style="$breakpoint.mdAndDown ? '' : 'margin-top: -30px !important;'">
        <div class="col-12 d-flex flex-column mt-4" >
            <service-tab/>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
            <div 
                class="card border-radius-top-left-0"
                :class="[ $breakpoint.smAndDown ? 'mb-4' : 'pb-3' ]"
                v-if="tabSelected.tabIndex === 0"
            >
                <div 
                    :class="[!$breakpoint.smAndDown ? 'pb-3' : 'p-0']"
                >
                    <spot-table />
                </div>
                <div 
                    :class="[!$breakpoint.smAndDown ? 'px-4 py-3' : 'pb-3 px-3']"
                >
                    <live-prices />
                </div>
            </div>
            <contracts-table class="card border-radius-top-left-0"  v-else-if="tabSelected.tabIndex===1"/> 
            <delivered-in-table class="card border-radius-top-left-0"  v-else-if="tabSelected.tabIndex===2"/> 
        </div>
      </div>
    </div>
</template>


<script>
import { mapState, mapActions } from 'vuex'
import breakpoint from '@/mixins/index'
import PageRefreshMixin from '@/mixins/PageRefreshMixin'
import ServiceTab from './Service/ServiceTab.vue'
import SpotTable from './OffersTable/SpotTable.vue'
import DeliveredInTable from './OffersTable/DeliveredInTable.vue'
import ContractsTable from './OffersTable/ContractsTable.vue'
import LivePrices from '../LivePrices/LivePrices.vue'
import RefreshInformation from '@/components/RefreshInformation.vue';

export default {
    mixins: [breakpoint, PageRefreshMixin],
    components:{
        ServiceTab,
        SpotTable,
        DeliveredInTable,
        ContractsTable,
        LivePrices,
        RefreshInformation,
    },
    watch: {
        'tabSelected.tabIndex' () {
            if (this.tabSelected.tabIndex === 1) {
                this.getRelationships();
            }
        }
    },
    computed:{
        ...mapState('sellerOffers',['showTerminalModal']),
        ...mapState('sellerTabs',['tabSelected']),
        ...mapState('livePrices',['showDailyPriceModal']),
        ...mapState('login', ['userLoggedIn']),
    
    },
    methods: {
        ...mapActions('accounts',['getRelationships']),
        ...mapActions('sellerOffers', ['getOffersTimeAvailability', 'getAllOffersForUser']),
        refreshPageData() {
            this.getOffersTimeAvailability();
            this.getAllOffersForUser();
        },
    },
    created() {
        this.getOffersTimeAvailability();
        this.getAllOffersForUser();
        this.startPageRefresh(this.refreshPageData);
    },
}
</script>